<template>
  <div class="parent-list-table" v-loading="loading">
    <el-table
      ref="table"
      row-key="id"
      class="el-table--simple"
      v-if="rows && rows.length > 0"
      :data="rows"
      @sort-change="doChangeSort"
    >
      <!-- <el-table-column type="selection" width="55"></el-table-column> -->

      <!-- Name -->
      <el-table-column sortable="custom"  :label="i18n('entities.parent.fields.name')" min-width="100">
        <template slot-scope="scope">
          <div
            class="list__avatar"
            v-if="scope.row.picture"
            :style="{ backgroundImage: getAvatar(scope.row) }"
          />
          <el-tooltip
            :disabled="!hasPermissionToAuditLogs"
            effect="dark"
            :content="scope.row.id"
            placement="bottom"
          >
            <span
              class="list__avatar__name"
              v-if="scope.row.firstName && scope.row.lastName"
              v-text="`${presenter(scope.row, 'firstName')} ${presenter(scope.row, 'lastName')}`"
            />
            <span v-else v-text="'-'" />
          </el-tooltip>
        </template>
      </el-table-column>

      <!-- Gender -->
      <el-table-column
        
        :label="fields.gender.label"
        :prop="fields.gender.name"
        min-width="50"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.gender"
            v-text="presenter(scope.row, 'gender')"
          />
          <span
            v-else
            v-text="'-'"
          />
        </template>
      </el-table-column>

      <!-- Birthdate -->
      <el-table-column
        
        :label="fields.birthdate.label"
        :prop="fields.birthdate.name"
        min-width="70"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.birthdate"
            v-text="presenter(scope.row, 'birthdate')"
          />
          <span
            v-else
            v-text="'-'"
          />
        </template>      
      </el-table-column>

      <!-- Phone Number -->
      <el-table-column
        v-if="!isPropertyNBA"
        :label="fields.phoneNumber.label"
        :prop="fields.phoneNumber.name"
        min-width="70"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.phoneNumber"
            v-text="presenter(scope.row, 'phoneNumber')"
          />
          <span
            v-else
            v-text="'-'"
          />
        </template>   
      </el-table-column>

      <!-- Email -->
      <el-table-column
        v-if="isPropertyNBA"
        
        :label="fields.email.label"
        :prop="fields.email.name"
        min-width="90"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'email') }}</template>
      </el-table-column>

      <!-- Created At -->
      <!-- <el-table-column
        v-if="hasPermissionToAuditLogs"
        :label="fields.createdAt.label"
        :prop="fields.createdAt.name"
        sortable="custom"
      >
        <template slot-scope="scope">{{ presenter(scope.row, 'createdAt') }}</template>
      </el-table-column> -->

      <!-- Last login -->
      <el-table-column
        :label="fields.lastLogin.label"
        :prop="fields.lastLogin.name"
        :resizable="false"
        :width="170"
        sortable="custom"
      >
        <template slot-scope="scope">
          <span
            v-if="scope.row.lastLogin"
            v-text="presenter(scope.row, 'lastLogin')"
          />
          <app-i18n
            v-else
            code="common.never"
          />
        </template>
      </el-table-column>

      <!-- Actions -->
      <el-table-column v-if="!isDisabledActionsColumn" :fixed="isMobile? undefined : 'right'" align="center" min-width="180">
        <template slot-scope="scope">
          <div class="table-actions">
            <!-- <router-link :to="`/parent/${scope.row.id}/${subpropertyId}`">
              <el-button type="text">
                <app-i18n code="common.view"></app-i18n>
              </el-button>
            </router-link> -->

            <router-link :to="`/parent/${scope.row.id}/edit/${subpropertyId}`" v-if="hasPermissionToEdit">
              <el-button
                icon="icon-pen"
                circle
              />
            </router-link>

           <el-button
              :disabled="destroyLoading"
              @click="doDestroyWithConfirm(scope.row.id)"
              circle
              v-if="hasPermissionToDestroy"
              icon="icon-trash"
            />
          </div>
        </template>
      </el-table-column>
    </el-table>

    <app-empty-page
      v-else
      :icon-class="'icon-player'"
      :empty-text="i18n('entities.parent.empty')"
    />

    <div class="el-pagination-wrapper" v-if="rows && rows.length > 0">
      <el-pagination
        :current-page="pagination.currentPage || 1"
        :disabled="loading"
        :layout="paginationLayout"
        :total="count"
        @current-change="doChangePaginationCurrentPage"
        @size-change="doChangePaginationPageSize"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import { AuditLogPermissions } from '@modules/audit-log/audit-log-permissions';
import { ParentModel } from '@modules/parent/parent-model';
import { mapGetters, mapActions } from 'vuex';
import { ParentPermissions } from '@modules/parent/parent-permissions';
import { i18n } from '@shared/i18n';

const IS_DISABLED_ACTIONS_COLUMN = true;

export default {
  name: 'app-parent-list-table',

  props: {
    subpropertyId: {
      type: String,
      required: true
    }
  },

  // async mounted() {
  //   this.doFetch({ subpropertyId: this.subpropertyId });
  // },

  computed: {
    ...mapGetters({
      rows: 'parent/list/rows',
      playerRows: 'player/list/rows',
      count: 'parent/list/count',
      loading: 'parent/list/loading',
      pagination: 'parent/list/pagination',
      isMobile: 'layout/isMobile',
      currentUser: 'auth/currentUser',
      destroyLoading: 'parent/destroy/loading',
      paginationLayout: 'layout/paginationLayout',
      isPropertyNBA: 'auth/manage/isPropertyNBA',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),

    hasPermissionToAuditLogs() {
      return new AuditLogPermissions(this.currentUser).read;
    },

    hasPermissionToEdit() {
      return new ParentPermissions(this.currentUser).edit;
    },

    hasPermissionToDestroy() {
      return new ParentPermissions(this.currentUser).destroy;
    },

    fields() {
      const { dateFormat, timeFormat} = this;
      return new ParentModel({ dateFormat, timeFormat }).fields();
    },

    isDisabledActionsColumn() {
      return IS_DISABLED_ACTIONS_COLUMN;
    }
  },

  methods: {
    ...mapActions({
      doChangeSort: 'parent/list/doChangeSort',
      doChangePaginationCurrentPage: 'parent/list/doChangePaginationCurrentPage',
      doChangePaginationPageSize:
        'parent/list/doChangePaginationPageSize',
      doDestroy: 'parent/destroy/doDestroy',
      doFetch: 'parent/list/doFetch',
    }),

    presenter(row, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new ParentModel({ dateFormat, timeFormat }).presenter(row, fieldName);
    },

    async doDestroyWithConfirm(id) {
      try {
        await this.$confirm(
          i18n('common.areYouSure'),
          i18n('common.confirm'),
          {
            confirmButtonText: i18n('common.yes'),
            cancelButtonText: i18n('common.no'),
            type: 'warning',
          },
        );

        return this.doDestroy({id, subpropertyId: this.subpropertyId});
      } catch (error) {
        // no
      }
    },

    getAvatar(row) {
      if (!('picture' in row)) return null;
      if (!(row.picture instanceof Array)) return null;
      if (!row.picture.length) return null;
      return `url("${row.picture[0].publicUrl}")`;
    },

    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style>
.parent-list-table .el-table:not(.el-table--simple) td:last-of-type .cell {
  padding: 0 30px;
}
.parent-list-table .el-table__row {
  cursor: default;
}
</style>
